import { Link } from "react-router-dom";

// Project modules
import ControlButtons from "../../Components/ControlButtons/ControlButtons";

/**
 * Cheater
 * -------
 * Guard screen shown when a user attempts to access a restricted route/state.
 * Behaviour:
 * - Encourages fair play and provides a clear path back to the start.
 */

const Cheater: React.FC = () => {
  /** RENDER -------------------------------------------------------- */
  return (
    <div className="escape-room">
      <div id="escapeRoomContainer">
        <ControlButtons />

        <div className="room" id="cheatsNeverProsper">
          <div className="winner-wrap">
            <div className="cheater" />

            <div className="winner-stats-card">
              <div className="winner-stats">
                <p>Looks like you tried to sneak out of the Escape Room.</p>
                <p>Let’s play fair and try again from the start.</p>

                <Link to="/">
                  <button className="btn-blue" style={{ marginTop: 8, marginBottom: 8 }}>
                    Go back to the start
                  </button>
                </Link>
              </div>
            </div>
          </div>
          {/* /winnerWrap */}
        </div>
      </div>
    </div>
  );
};

export default Cheater;